import { reactive, getCurrentInstance, ref, computed, watch, onMounted, onBeforeUnmount, toRefs, nextTick, resolveComponent, withDirectives, openBlock, createElementBlock, normalizeClass, normalizeStyle, createCommentVNode, renderSlot, createBlock, createElementVNode, createTextVNode, toDisplayString, Fragment, renderList, withModifiers, vShow } from 'vue';
import { useExpose } from './utils/hooks';
import { createComponent } from './utils/create-component';
import { RIGHT_CLICK_EVENT, CLICK_EVENT } from './utils/constants';
import propTypes from './utils/prop-types';
import Icon from './icon';
import { bindPropToNode, bindOurFnToEventOfNode } from './utils/vnode';
import { preventDefault } from './utils/dom';
import mitt from 'mitt';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }
      return ContinueSentinel;
    }
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var props = {
  /**
   * 主题样式
   */
  type: propTypes.string().def('default'),
  /**
   * 右侧是否为关闭图标
   */
  closeable: propTypes["boolean"]().def(false),
  /**
   * 右侧是否为链接图标
   */
  linkable: propTypes["boolean"]().def(false),
  /**
   * 通告栏内容
   */
  text: propTypes.oneOfType([propTypes.string(), propTypes.array()]).def(''),
  /**
   * 圆角展示
   */
  round: propTypes["boolean"]().def(false),
  /**
   * 内容超出滚动展示（如果不滚动且内容超出则超出部分展示省略号)——横向滚动
   */
  scrollable: propTypes["boolean"]().def(false),
  /**
   * 是否开启文本换行，只在禁用滚动时生效
   */
  wrapable: propTypes["boolean"]().def(false),
  /**
   * 滚动速率（px/s）
   */
  speed: propTypes.oneOfType([propTypes.string(), propTypes.number()]).def(60),
  /**
   * 动画延迟时间（ms）——横向滚动
   */
  delay: propTypes.oneOfType([propTypes.string(), propTypes.number()]).def(1000),
  /**
   * 两次滚动之间的间距（px）——横向滚动
   */
  spacing: propTypes.oneOfType([propTypes.string(), propTypes.number()]).def(0),
  /**
   * 左侧图标名称或图片链接，等同于Icon组件的name属性
   */
  leftIcon: propTypes.string(),
  /**
   * 模式为链接时的右侧文字（和链接图标共存）
   */
  linkText: propTypes.string(),
  /**
   * 模式为关闭时右侧文字（和关闭图标互斥）
   */
  closeText: propTypes.string(),
  /**
   * 滚动方向
   */
  direction: propTypes.string().def('horizontal'),
  /**
   * 纵向滚动高度
   */
  height: propTypes.oneOfType([propTypes.string(), propTypes.number()]).def(40)
};
var verticalScrollItemProps = {
  item: propTypes.object(),
  style: propTypes.object(),
  key: propTypes.string()
};
var emits = [RIGHT_CLICK_EVENT, CLICK_EVENT];

var _components;
// 用来同VerticalScrollItem组件通信
var verticalScrollItemEmitter = mitt();
var _createComponent = createComponent('notice-bar'),
  create = _createComponent.create,
  className = _createComponent.className;
var script = create({
  components: (_components = {}, _defineProperty(_components, Icon.name, Icon), _defineProperty(_components, "VerticalScrollItem", {
    props: verticalScrollItemProps,
    setup: function setup(props) {
      var node = props.item;
      var handleClick = function handleClick(e) {
        // 阻止冒泡和默认行为
        preventDefault(e, true);
        verticalScrollItemEmitter.emit('verticalScrollItemClick', node.key);
      };
      bindPropToNode(node, 'style', props.style);
      bindOurFnToEventOfNode(node, 'onClick', handleClick);
      return function () {
        return node;
      };
    }
  }), _components),
  props: props,
  emits: emits,
  setup: function setup(props, _ref) {
    var emit = _ref.emit,
      slots = _ref.slots;
    var state = reactive({
      show: true,
      ellipsis: false,
      showHorizontalClone: false,
      horizontalContent: props.text,
      horizontalDuration: 0,
      horizontalTextWidth: 0,
      horizontalNoticeWindowWidth: 0,
      horizontalSpacing: +props.spacing,
      showVerticalAnimate: false,
      verticalDuration: +props.height / +props.speed / 4 * 1000,
      verticalScrollList: []
    });
    var instance = getCurrentInstance();
    var uid = instance && instance.uid;
    // 横向滚动外层区域dom
    var noticeWindowRef = ref();
    // 横向滚动内容dom
    var textRef = ref();
    // 纵向滚动定时器
    var verticalTimer;
    // 是否为横向滚动
    var isHorizontalScroll = computed(function () {
      return props.direction === 'horizontal';
    });
    // 是否为纵向滚动
    var isVerticalScroll = computed(function () {
      return props.direction === 'vertical';
    });
    // 是否可滚动
    var computedScrollable = computed(function () {
      var computedResult;
      if (props.scrollable === false) {
        // 如果设置props.scrollable为false，那么无论如何禁止滚动
        computedResult = false;
      } else if (isVerticalScroll.value) {
        // 如果是纵向滚动，以props.scrollable为准
        computedResult = props.scrollable;
      } else {
        // 如果是横向滚动，看文本宽度是否超过窗口宽度
        computedResult = state.horizontalTextWidth > state.horizontalNoticeWindowWidth;
      }
      return computedResult;
    });
    // 省略
    var ellipsis = computed(function () {
      // 每次text的改变均要重置ellipsis为false，以保证每次计算scrollable时均能获得原始的horizontalTextWidth
      if (state.horizontalTextWidth && state.horizontalNoticeWindowWidth) {
        return !computedScrollable.value && !props.wrapable;
      }
      return false;
    });
    // class样式
    var classes = computed(function () {
      var type = props.type,
        round = props.round,
        wrapable = props.wrapable;
      return [className, "".concat(className, "-").concat(type), round && "".concat(className, "-round"), wrapable && "".concat(className, "-wrapable")];
    });
    var noticeBarStyle = computed(function () {
      var styles = {};
      if (props.direction === 'vertical') {
        styles = {
          height: "".concat(props.height, "px")
        };
      }
      return styles;
    });
    var contentBoxClasses = computed(function () {
      return ["".concat(className, "__content_box"), ellipsis.value && "".concat(className, "__content_box-ellipsis"), props.wrapable && "".concat(className, "__content_box-wrapable")];
    });
    // 右侧文字
    var rightText = computed(function () {
      return props.closeable ? props.closeText : props.linkText;
    });
    // 右侧图标
    var rightIcon = computed(function () {
      if (props.closeable) {
        return props.closeText ? '' : 'base_close_24';
      } else {
        return 'base_next_24';
      }
    });
    // 横向滚动区域样式
    var horizontalTextStyle = computed(function () {
      if (computedScrollable.value) {
        return {
          animation: "".concat(state.horizontalDuration, "s sp-words-loop_").concat(uid, " linear infinite both")
        };
      }
      return null;
    });
    // 纵向滚动列表样式
    var verticalListStyle = computed(function () {
      var styles = {};
      if (state.showVerticalAnimate) {
        var duration = state.verticalDuration / 1000;
        styles = {
          transition: "all ".concat(duration, "s"),
          'margin-top': "-".concat(props.height, "px")
        };
      }
      return styles;
    });
    // 纵向滚动的每一列样式
    var verticalItemStyle = computed(function () {
      var styles = {};
      if (props.direction === 'vertical') {
        styles = {
          height: props.height + 'px',
          lineHeight: props.height + 'px'
        };
      }
      return styles;
    });
    /**
     * @description: 处理横向滚动逻辑
     * @param {*}
     * @return {*}
     */
    function handleHorizontalAnimation() {
      var distance = +state.horizontalTextWidth + +state.horizontalSpacing + 8; // spacing循环间距 8补偿距离
      var keyframesString = "@keyframes sp-words-loop_".concat(uid, " {\n                    0% {\n                        transform: translateX(0px);\n                    }\n                    100% {\n                        transform: translateX(-").concat(distance, "px);\n                    }\n                }\n                @-webkit-keyframes sp-words-loop_").concat(uid, " {\n                    0% {\n                        transform: translateX(0px);\n                    }\n                    100% {\n                        transform: translateX(-").concat(distance, "px);\n                    }\n                }");
      var style = document.getElementById("__words_loop_stylesheet_".concat(uid));
      if (!style) {
        style = document.createElement('style');
        style.id = "__words_loop_stylesheet_".concat(uid);
        style.type = 'text/css';
      }
      style.innerHTML = keyframesString;
      document.head.appendChild(style);
    }
    /**
     * @description: 初始化横向滚动逻辑
     * @param {*}
     * @return {*}
     */
    function initHorizontalAnimation() {
      if (!computedScrollable.value) return;
      state.horizontalSpacing = +props.spacing || noticeWindowRef.value && noticeWindowRef.value.clientWidth;
      state.horizontalDuration = (state.horizontalTextWidth + state.horizontalSpacing) / +props.speed;
      state.showHorizontalClone = true;
      handleHorizontalAnimation();
    }
    /**
     * @description: 处理纵向滚动逻辑
     * @param {*}
     * @return {*}
     */
    function handleVerticalAnimation() {
      if (!computedScrollable.value) return;
      state.showVerticalAnimate = true;
      setTimeout(function () {
        state.verticalScrollList.push(state.verticalScrollList[0]);
        state.verticalScrollList.shift();
        state.showVerticalAnimate = false;
      }, state.verticalDuration);
    }
    /**
     * @description: 初始化循环纵向滚动逻辑
     * @param {*}
     * @return {*}
     */
    function initVerticalAnimation() {
      handleVerticalAnimation();
      var standMs = state.verticalDuration + +props.delay;
      verticalTimer = setInterval(handleVerticalAnimation, standMs);
    }
    /**
     * @description: 右侧区域点击
     * @param {Event} e
     * @return {*}
     */
    function onRightBoxClick(e) {
      if (props.closeable) {
        state.show = false;
      }
      emit(RIGHT_CLICK_EVENT, e);
    }
    /**
     * @description: 通告栏区域点击
     * @param {Event} e
     * @return {*}
     */
    function onNoticeBarClick(e) {
      emit(CLICK_EVENT, e);
    }
    /**
     * @description: 纵向滚动区域点击
     * @param {String} items
     * @return {*}
     */
    function onVerticalItemClick(str) {
      // 通过 item 寻找 index
      if (Array.isArray(props.text)) {
        var index = props.text.findIndex(function (item) {
          return item === str;
        });
        emit(CLICK_EVENT, index);
      }
    }
    function updateHorizontalTextWidth() {
      return _updateHorizontalTextWidth.apply(this, arguments);
    }
    function _updateHorizontalTextWidth() {
      _updateHorizontalTextWidth = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return nextTick();
              case 2:
                state.horizontalTextWidth = textRef.value && textRef.value.clientWidth;
              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _updateHorizontalTextWidth.apply(this, arguments);
    }
    verticalScrollItemEmitter.on('verticalScrollItemClick', function (item) {
      emit(CLICK_EVENT, item);
    });
    /**
     * @description: 初始化横向/纵向数据
     * @param {String | String[]} text
     * @return {*}
     */
    function initData(_x) {
      return _initData.apply(this, arguments);
    }
    /**
     * @description: 初始化横向/纵向动画
     * @param {*}
     * @return {*}
     */
    function _initData() {
      _initData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(text) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!isHorizontalScroll.value) {
                  _context2.next = 7;
                  break;
                }
                // 横向滚动
                state.horizontalContent = Array.isArray(text) ? text[0] : text;
                _context2.next = 4;
                return updateHorizontalTextWidth();
              case 4:
                state.horizontalNoticeWindowWidth = noticeWindowRef.value && noticeWindowRef.value.clientWidth;
                _context2.next = 8;
                break;
              case 7:
                // 纵向滚动
                if (slots["default"] && slots["default"]()[0]) {
                  state.verticalScrollList = [].concat(slots["default"]()[0].children);
                } else {
                  state.verticalScrollList = Array.isArray(text) ? _toConsumableArray(text) : [text];
                }
              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _initData.apply(this, arguments);
    }
    function init() {
      initData(props.text);
      setTimeout(function () {
        isHorizontalScroll.value ? initHorizontalAnimation() : initVerticalAnimation();
      }, +props.delay);
    }
    /**
     * @description: 删除 style 节点
     * @return {*}
     */
    function deleteStyleNode() {
      var styleNode = document.getElementById("__words_loop_stylesheet_".concat(uid));
      if (styleNode && styleNode.parentNode) {
        styleNode.parentNode.removeChild(styleNode);
      }
    }
    watch(function () {
      return props.text;
    }, function (val) {
      init();
    });
    watch(function () {
      return state.ellipsis;
    }, function () {
      // ellipsis会影响内容宽度，因此要重新计算
      updateHorizontalTextWidth();
    });
    onMounted(function () {
      init();
    });
    onBeforeUnmount(function () {
      verticalScrollItemEmitter.all.clear();
      verticalTimer && clearInterval(verticalTimer);
      // 删除style节点
      deleteStyleNode();
    });
    useExpose({
      // 重置
      reset: function reset() {
        if (isHorizontalScroll.value) {
          deleteStyleNode();
          init();
        }
      }
    });
    return _objectSpread2(_objectSpread2({}, toRefs(state)), {}, {
      slots: slots,
      noticeWindowRef: noticeWindowRef,
      textRef: textRef,
      className: className,
      contentBoxClasses: contentBoxClasses,
      rightText: rightText,
      rightIcon: rightIcon,
      classes: classes,
      noticeBarStyle: noticeBarStyle,
      horizontalTextStyle: horizontalTextStyle,
      isHorizontalScroll: isHorizontalScroll,
      isVerticalScroll: isVerticalScroll,
      verticalListStyle: verticalListStyle,
      verticalItemStyle: verticalItemStyle,
      onNoticeBarClick: onNoticeBarClick,
      onRightBoxClick: onRightBoxClick,
      onVerticalItemClick: onVerticalItemClick
    });
  }
});

var _hoisted_1 = ["onClick"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_sp_icon = resolveComponent("sp-icon");
  var _component_VerticalScrollItem = resolveComponent("VerticalScrollItem");
  return withDirectives((openBlock(), createElementBlock("div", {
    "class": normalizeClass(_ctx.classes),
    style: normalizeStyle(_ctx.noticeBarStyle),
    onClick: _cache[1] || (_cache[1] = function () {
      return _ctx.onNoticeBarClick && _ctx.onNoticeBarClick.apply(_ctx, arguments);
    })
  }, [createCommentVNode("左侧区域 "), _ctx.slots.left || _ctx.leftIcon ? (openBlock(), createElementBlock("div", {
    key: 0,
    "class": normalizeClass(["".concat(_ctx.className, "__left"), !_ctx.slots.left && !_ctx.leftIcon && "".concat(_ctx.className, "__left-empty")])
  }, [renderSlot(_ctx.$slots, "left", {}, function () {
    return [_ctx.leftIcon ? (openBlock(), createBlock(_component_sp_icon, {
      key: 0,
      name: _ctx.leftIcon,
      "class": normalizeClass("".concat(_ctx.className, "-").concat(_ctx.type))
    }, null, 8 /* PROPS */, ["name", "class"])) : createCommentVNode("v-if", true)];
  })], 2 /* CLASS */)) : createCommentVNode("v-if", true), createCommentVNode("通告栏内容 横向滚动"), _ctx.isHorizontalScroll ? (openBlock(), createElementBlock("div", {
    key: 1,
    "class": normalizeClass(["".concat(_ctx.className, "__content"), _ctx.wrapable && "".concat(_ctx.className, "__content-wrapable")]),
    ref: "noticeWindowRef"
  }, [createElementVNode("div", {
    ref: "textRef",
    "class": normalizeClass(_ctx.contentBoxClasses),
    style: normalizeStyle(_ctx.horizontalTextStyle)
  }, [renderSlot(_ctx.$slots, "default", {}, function () {
    return [createTextVNode(toDisplayString(_ctx.horizontalContent), 1 /* TEXT */)];
  }), _ctx.showHorizontalClone ? (openBlock(), createElementBlock("span", {
    key: 0,
    style: normalizeStyle("display: inline-block;width: ".concat(_ctx.horizontalSpacing, "px"))
  }, null, 4 /* STYLE */)) : createCommentVNode("v-if", true), createCommentVNode(" 复制一份用于循环滚动 "), _ctx.showHorizontalClone ? renderSlot(_ctx.$slots, "default", {
    key: 1
  }, function () {
    return [createTextVNode(toDisplayString(_ctx.horizontalContent), 1 /* TEXT */)];
  }) : createCommentVNode("v-if", true)], 6 /* CLASS, STYLE */)], 2 /* CLASS */)) : createCommentVNode("v-if", true), createCommentVNode("通告栏内容 纵向滚动"), _ctx.verticalScrollList.length > 0 && _ctx.isVerticalScroll ? (openBlock(), createElementBlock("div", {
    key: 2,
    style: normalizeStyle({
      height: _ctx.height + 'px'
    }),
    "class": normalizeClass("".concat(_ctx.className, "__content_vertical"))
  }, [_ctx.slots["default"] ? (openBlock(), createElementBlock("div", {
    key: 0,
    "class": normalizeClass("".concat(_ctx.className, "__content_vertical_list")),
    style: normalizeStyle(_ctx.verticalListStyle)
  }, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.verticalScrollList, function (item) {
    return openBlock(), createBlock(_component_VerticalScrollItem, {
      key: item.key,
      style: normalizeStyle(_ctx.verticalItemStyle),
      item: item
    }, null, 8 /* PROPS */, ["style", "item"]);
  }), 128 /* KEYED_FRAGMENT */))], 6 /* CLASS, STYLE */)) : (openBlock(), createElementBlock("ul", {
    key: 1,
    "class": normalizeClass("".concat(_ctx.className, "__content_vertical_list")),
    style: normalizeStyle(_ctx.verticalListStyle)
  }, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.verticalScrollList, function (item, index) {
    return openBlock(), createElementBlock("li", {
      "class": normalizeClass("".concat(_ctx.className, "__content_vertical_list_item")),
      key: index,
      style: normalizeStyle(_ctx.verticalItemStyle),
      onClick: withModifiers(function ($event) {
        return _ctx.onVerticalItemClick(item);
      }, ["stop"])
    }, toDisplayString(item), 15 /* TEXT, CLASS, STYLE, PROPS */, _hoisted_1);
  }), 128 /* KEYED_FRAGMENT */))], 6 /* CLASS, STYLE */))], 6 /* CLASS, STYLE */)) : createCommentVNode("v-if", true), createCommentVNode("右侧区域 "), _ctx.slots.right || _ctx.closeable || _ctx.linkable ? (openBlock(), createElementBlock("div", {
    key: 3,
    "class": normalizeClass(["".concat(_ctx.className, "__right"), _ctx.round && "".concat(_ctx.className, "__right-round")])
  }, [renderSlot(_ctx.$slots, "right", {}, function () {
    return [_ctx.closeable || _ctx.linkable ? (openBlock(), createElementBlock("div", {
      key: 0,
      "class": normalizeClass("".concat(_ctx.className, "__right-mode")),
      onClick: _cache[0] || (_cache[0] = withModifiers(function () {
        return _ctx.onRightBoxClick && _ctx.onRightBoxClick.apply(_ctx, arguments);
      }, ["stop"]))
    }, [_ctx.rightText ? (openBlock(), createElementBlock("div", {
      key: 0,
      "class": normalizeClass([_ctx.closeText && "".concat(_ctx.className, "__right-close")])
    }, toDisplayString(_ctx.rightText), 3 /* TEXT, CLASS */)) : createCommentVNode("v-if", true), _ctx.rightIcon ? (openBlock(), createBlock(_component_sp_icon, {
      key: 1,
      name: _ctx.rightIcon,
      "class": normalizeClass("".concat(_ctx.className, "-").concat(_ctx.type))
    }, null, 8 /* PROPS */, ["name", "class"])) : createCommentVNode("v-if", true)], 2 /* CLASS */)) : createCommentVNode("v-if", true)];
  })], 2 /* CLASS */)) : createCommentVNode("v-if", true)], 6 /* CLASS, STYLE */)), [[vShow, _ctx.show]]);
}

script.render = render;
script.__file = "components/src/component/notice-bar/notice-bar.vue";

/*
 * @Description: NoticeBar 通告栏导出文件
 * @Author: duqiao@kuaishou.com
 * @Date: 2022-03-10 16:26:53
 * @LastEditors: zhoushichao@kuaishou.com
 * @LastEditTime: 2023-02-02 11:08:37
 */
var _NoticeBar = script;

export { _NoticeBar as default };
